export default __webpack_public_path__ + "7028847fcb509f34b5c83b1970ddbe5b.png";